import Vue from 'vue';
// import { FIREBASE_URL } from "@/api/const.js";
import { BASE_URL } from '@/api/const.js';

export default {
    // new user registration
    // create(signupData) {
    // 	return Vue.http.post(
    // 		FIREBASE_URL +
    // 			"signupNewUser?key=AIzaSyDjbP0TLnADQNhUy20jIEyFk5Y1LrrTqB4",
    // 		{
    // 			email: signupData.email,
    // 			password: signupData.password,
    // 			returnSecureToken: true
    // 		}
    // 	);
    // },

    signin(signinData) {
        return Vue.http.post(BASE_URL + 'auth/login/', {
            phone: signinData.phone,
            password: signinData.password,
        });
    },

    // recovery user password via email
    pswdEmailRecovery(recoveryData) {
        return Vue.http.post(BASE_URL + 'auth/reset_password/', recoveryData);
    },

    // passwordRecovery(recoveryData) {
    // 	return Vue.http.post(BASE_URL + "auth/reset_password/", recoveryData);
    // },

    // get user profile
    fetchUser() {
        return Vue.http.get(BASE_URL + 'userdata/profile/');
    },
};
